import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Tariff } from '@personal-area/global/accounts/models';
import { TariffState } from '../reducers/tariffs';

const getTariffsStore = createFeatureSelector<TariffState>('tariffs');

export const getTariffs = createSelector(
  getTariffsStore,
  (state: TariffState): Tariff[] => state.tariffs,
);

export const areTariffsLoading = createSelector(
  getTariffsStore,
  (state: TariffState): boolean => state.isLoading,
);

export const areTariffsLoaded = createSelector(
  getTariffsStore,
  (state: TariffState): boolean => state.isLoaded,
);
